import React from 'react'
import { OverlayTrigger, Tooltip } from "react-bootstrap"

import {
  presenceErrorClass,
} from 'servos/formValidations'

import SelectBox from '../common/SelectBox'
import ProfileInput from '../common/ProfileInput'

const colours = [
  { value: 'Green', label: 'Green' },
  { value: 'Yellow', label: 'Yellow' },
  { value: 'Blue', label: 'Blue' },
]

class Medicare extends React.Component {

  render() {
    const {
      firstName,
      lastName,
      errors,
      handleMedicareCardColour,
      handleInput,
      medicareCardNumber,
      medicareRefNumber,
      medicareMiddlenameOnCard,
      medicareCardColour,
      medicareValidTo,
    } = this.props

    const tooltip = (
      <Tooltip id="tooltip" bsClass="tooltip" style={{ backgroundColor: 'white' }}>
        <strong>
        Reference number is the single digit number that appears on the left of the cardholder's name on the Medicare card. It distinguishes the individuals named on the card.
        </strong>
      </Tooltip>
    );

    return (
      <div className='ml-2 pl-3 pt-2 border-left border-green'>
        <div className='form-group'>
          <div className="row mt-2">
            <ProfileInput
              id='medicareCardNumber'
              label='Card Number'
              className='col-6'
              value={medicareCardNumber}
              handleInput={handleInput}
              errors={errors}
            />
          </div>

          <div className="row mt-2">
            <ProfileInput
              id='medicareRefNumber'
              label='Reference number'
              className='col-6'
              value={medicareRefNumber}
              handleInput={handleInput}
              errors={errors}
            >
              <OverlayTrigger
                placement="top"
                overlay={tooltip}
              >
                <i className="fa fa-info-circle" />
              </OverlayTrigger>
            </ProfileInput >
          </div>

          <div className="row mt-2">
            <div className='col-4'>
              <label>
                <span>First name</span>
              </label>
              <input
                className="form-control"
                value={ firstName }
                disabled
              />
            </div>
            <ProfileInput
              id='medicareMiddlenameOnCard'
              placeholder='as on card'
              label='Middle name'
              className='col-4'
              value={medicareMiddlenameOnCard}
              handleInput={handleInput}
              errors={errors}
            />
            <div className='col-4'>
              <label>
                <span>Last name</span>
              </label>
              <input
                className="form-control"
                value={ lastName }
                disabled
              />
            </div>
          </div>
          <div className="row mt-2">
            <SelectBox
              label={'Card Colour'}
              selectedOption={colours.filter( ({value}) => value == medicareCardColour) }
              onChange={handleMedicareCardColour}
              options={colours}
              errorMessage={errors['medicareCardColour']}
              className='col-6'
            />
          </div>
          <div className="row mt-2">
            <ProfileInput
              id='medicareValidTo'
              className='col-6'
              value={medicareValidTo}
              label='Valid to'
              handleInput={handleInput}
              errors={errors}
            />
          </div>
        </div>
      </div>
    )
  }
}

export default Medicare;
